<template>
  <div>
    <b-table stacked="sm" hover :fields="fields" :items="invoiceList" v-if="invoiceList.length">
      <template slot="total" slot-scope="data">
        {{ parseInt(data.value).toFixed(2) }} kr
      </template>

      <template slot="HEAD_total">
        Total
        <i
          v-b-tooltip.hover
          title="Verdi per innløst opplevelse. Utsalgspris - provisjon(eks. mva)."
          class="fa fa-info-circle hoverable"
        ></i>
      </template>

      <template slot="HEAD_verdibevis">
        Verdibevis
        <i
          v-b-tooltip.hover
          title="Verdibevisnummer som har blitt løst inn"
          class="fa fa-info-circle hoverable"
        ></i>
      </template>

      <template slot="HEAD_navn">
        Navn
        <i
          v-b-tooltip.hover
          title="Navn på opplevelsen som har blitt løst inn"
          class="fa fa-info-circle hoverable"
        ></i>
      </template>

      <template slot="HEAD_dato">
        Dato
        <i
          v-b-tooltip.hover
          title="Dato for når verdibeviset har blitt løst inn"
          class="fa fa-info-circle hoverable"
        ></i>
      </template>

      <template slot="dato" slot-scope="data">
        {{ formatDate(data.value) }}
      </template>
    </b-table>
    <b-alert :show="invoiceList.length === 0" variant="dark" class="text-center">
      <strong>Listen er tom!</strong> Løs inn verdibevis for å motta oppgjør
    </b-alert>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  format, //
  subDays,
  parseISO,
  isBefore,
} from 'date-fns';
import { nb } from 'date-fns/locale';

export default {
  data() {
    return {
      fields: ['verdibevis', 'navn', 'total', 'dato'],
    };
  },
  computed: {
    ...mapGetters({
      invoiceList: 'invoices/nextInvoiceTable',
    }),
  },
  methods: {
    formatInvoiceDate(date) {
      const invoiceDate = parseISO(date);
      if (isBefore(invoiceDate, new Date('2016-09-30 23:59:59'))) {
        return this.formatDate(invoiceDate);
      }
      return format(subDays(invoiceDate, 1), 'MMMM yyyy', { locale: nb });
    },
  },
};
</script>
